import {
    SCREEN_NAME,
    IMPRESSION_ACTIONS,
    CLICK_ACTIONS,
    SCREEN_VIEW_ACTIONS,
} from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const linkWalletAccountImpressionEvent = (
    walletName: string,
    source: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.LINK_WALLET_OTP,
        action: IMPRESSION_ACTIONS.IMPRESSION_LINK_WALLET,
        label: walletName,
        context: JSON.stringify({ source }),
    });
};

export const linkWalletAccountResendClickEvent = (
    walletName: string,
    source: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.LINK_WALLET_OTP,
        action: CLICK_ACTIONS.CLICK_LINK_WALLET_RESEND_OTP,
        label: walletName,
        context: JSON.stringify({ source }),
    });
};

export const linkWalletAccountVerifyClickEvent = (
    walletName: string,
    source: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.LINK_WALLET_OTP,
        action: CLICK_ACTIONS.CLICK_LINK_WALLET_VERIFY_AND_PROCEED,
        label: walletName,
        context: JSON.stringify({ source }),
    });
};

export const linkWalletAccountOtpErrorEvent = (
    walletName: string,
    source: string,
    message: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.LINK_WALLET_OTP,
        action: IMPRESSION_ACTIONS.IMPRESSION_LINK_WALLET_OTP_ERROR,
        label: walletName,
        context: JSON.stringify({ message, source }),
    });
};

export const clickLinkWalletEvent = (walletName: string, clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_LINK_WALLET,
        label: walletName,
    });
};

export const clickProceedLinkWalletEvent = (
    walletName: string,
    source: string,
    clickEvent: AnalyticsContextValue["clickEvent"],
): void => {
    clickEvent({
        category: SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_PROCEED_LINK_WALLET,
        label: walletName,
        context: JSON.stringify({ source }),
    });
};

export const linkAccountSuccessImpressionEvent = (
    walletName: string,
    source: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.LINK_WALLET_OTP,
        label: walletName,
        context: JSON.stringify({ source }),
        action: IMPRESSION_ACTIONS.IMPRESSION_LINK_WALLET_SUCCESS,
    });
};

export const linkAccountWithNumberScreenViewEvent = (
    walletName: string,
    source: string,
    editable: boolean,
    screenViewEvent: AnalyticsContextValue["screenViewEvent"],
): void => {
    screenViewEvent({
        category: SCREEN_NAME.PAYMENT,
        label: walletName,
        context: JSON.stringify({ source, editable }),
        action: SCREEN_VIEW_ACTIONS.VIEW_LINK_WALLET,
    });
};
